import React from 'react';

interface Props {
  className?: string;
  height?: number;
  width?: number;
  color?: string;
}

const ChevronDown = ({
  className = 'chevron-down-icon',
  height = 24,
  width = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    data-testid="chevron-down-icon"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.45 9.58L6.51 8.53L11.81 13.9C11.87 13.96 11.94 13.97 11.98 13.97C12.02 13.97 12.1 13.97 12.16 13.9L17.48 8.53L18.54 9.58L13.23 14.95C12.9 15.29 12.46 15.47 11.98 15.47C11.5 15.47 11.07 15.29 10.74 14.95L5.45 9.58Z"
      fill={color}
    />
  </svg>
);

export default ChevronDown;
